
import { Environment as CoreEnvironment, WebService } from '@portable/core/models';

class OIDCConfig {
    stsServer: WebService = new WebService();
    redirect_url: WebService = new WebService();
    post_login_route: WebService = new WebService();
	post_logout_redirect_uri: WebService = new WebService();
    silent_renew_url: WebService = new WebService();
	scope: 'accelerators.authentication.service.api openid' = 'accelerators.authentication.service.api openid';
	response_type: 'code';
    client_id: string = '';
	forbidden_route: string = '/aux/forbidden';
	unauthorized_route: string = '/aux/unauthorized';
	start_checksession: boolean = false;
	silent_renew: boolean = false;
	log_console_warning_active: boolean = false;
	log_console_debug_active: boolean = false;
	auto_clean_state_after_authentication: boolean = false;
    trigger_authorization_result_event: boolean = false;
	max_id_token_iat_offset_allowed_in_seconds: number = 0;

    constructor(options: any = { }) {
        var booleans = { true: true, false: false, null: false, undefined: false };

        this.stsServer = options.stsServer;
        this.redirect_url = options.redirect_url;
        this.post_login_route, options.post_login_route,
        this.post_logout_redirect_uri = options.post_logout_redirect_uri;
        this.silent_renew_url = options.silent_renew_url;
        this.scope = options.scope || this.scope;   
        this.response_type = options.response_type || this.response_type;
        this.client_id = options.client_id || this.client_id;
        this.forbidden_route = options.forbidden_route || this.forbidden_route;
        this.unauthorized_route = options.unauthorized_route || this.unauthorized_route;
        this.start_checksession = booleans[ options.start_checksession ];
        this.silent_renew = booleans[ options.silent_renew ];
        this.log_console_warning_active = booleans[ options.log_console_warning_active ];
        this.log_console_debug_active = booleans[ options.log_console_debug_active ];
        this.auto_clean_state_after_authentication = booleans[ options.auto_clean_state_after_authentication ];
        this.trigger_authorization_result_event = booleans[ options.trigger_authorization_result_event ];
        this.max_id_token_iat_offset_allowed_in_seconds = options.max_id_token_iat_offset_allowed_in_seconds || this.max_id_token_iat_offset_allowed_in_seconds;

        return this;
    }

}

class Environment extends CoreEnvironment {
    ids: WebService = new WebService();
    idsRoot: WebService = new WebService();  // Deprecated?
    angularRoot: WebService = new WebService();  // Deprecated?
    authConfig: OIDCConfig = new OIDCConfig();

    constructor(options: any = { }) {
        super(options);
    
        this.ids = options.ids || this.ids;
        this.idsRoot = options.idsRoot || this.idsRoot;
        this.angularRoot = options.angularRoot || this.angularRoot;
        this.authConfig = options.authConfig || this.authConfig;

        return this;
    }

}

export { Environment, OIDCConfig };
